webix.protoUI({
	name: "ssheet-suggest",
	defaults:{
		padding:0,
		css: "webix_ssheet_suggest"
	}
},webix.ui.contextmenu);